export const setFooter = {
  methods: {
    setFooter(data) {
      this.$store.dispatch("SET_FOOTER", data);
    },
  },
};
